export default "__VITE_ASSET__4fb68f68__"